<template>
  <v-container fluid no-gutters dense class="pt-0 mt-0">
  <v-row fluid dense align="center" justify="flex-start" class="pt-0 pb-0 mt-0 mb-0">
    <v-col cols="3" v-if="others" dense>
       <v-combobox 
          no-gutters
          v-model="applicationRoutesIdSelected"
          outlined
          dense
          label="*Uso"
          :items="applicationRoutesList"
          item-text="name"
          background-color="white"
          style="height: 40px;"
          :disabled="disabled"
        />
    </v-col>

    <v-col v-if="typeMedicine" cols="auto" dense class="p-0 m-0">
      <v-text-field
         v-uppercase
         v-model="medicineExtraName"
         outlined
         dense
         hide-details
         label="*Medicamento"
         type="string"
         background-color="white"
         :disabled="disabled"
         clearable
         />
       </v-col>

       <v-col v-if="!typeMedicine" cols="auto" dense>
          <QuerySearchDropdown
            v-model="medicine"
            :query="getMedicinesQuery"
            :query-key="['medicines', 'collection']"
            label="*Medicamento"
            item-text="name"
            input-prompt-text="Digite para pesquisar..."
            not-found-text="Nenhum medicamento encontrado."
            :error-messages="errors.medicine"
            :additional-variables="{
              disabled: false,
              applicationRouteId: applicationRoutesIdSelected.id || applicationRoute.id,
            }"
            style="height: 40px;
            background: blue;"
          />
        </v-col>  

        <v-col cols="auto" dense>
          <v-switch
            dense
            no-gutters
            v-model="typeMedicine"
            label="Medicamento Extra"
            :disabled="disabled"
          />
        </v-col>
        <v-col cols="auto" dense>
          <v-switch
            no-gutters
            dense
            v-model="continuous"
            label="Uso Contínuo"
            :disabled="disabled"
          />
        </v-col>
 <v-spacer />
  </v-row>

  <v-row no-gutters dense align="center" class="pt-0 pb-0 mt-0 mb-0">
          <span class="text-subtitle-2">Apresentações: </span>
              <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="light-blue" :attrs="attrs" v-on="on" >
              <v-icon >eva-info-outline</v-icon>
            </v-btn>
          </template>
          <span> para confirmar à adição da posologia, clique no ícone ao lado de "preferência de uso" </span>
        </v-tooltip>
  </v-row>

  <v-row fluid dense align="center" justify="flex-start" class="pt-0 pb-0 mt-0 mb-0">
    <v-col no-gutters dense >
      <v-row  dense>
        <v-col lg="2" dense >
          <v-combobox
            v-model="presentation"
            outlined
            dense
            label="Apresentação"
            :items="presentations"
            item-text="name"
            :hide-details="errors.presentation === undefined"
            :error-messages="errors.presentation"
            background-color="white"
            :disabled="disabled"
            @input="selectFirstElement"
          />
        </v-col>
        <v-col lg="2" dense>
          <v-text-field
            v-model="quantity"
              outlined
              dense
              hide-details
              label="Quantidade"
              type="number"
              :error-messages="errors.quantityUnity"
              background-color="white"
              :disabled="disabled || continuous"
              />
        </v-col>

        <v-col lg="2" dense>
         <v-combobox
            v-model="quantityUnity"
            outlined
            dense
            label="Elemento"
            :items="quantityUnities"
            item-text="name"
            :hide-details="errors.quantityUnity === undefined"
            :error-messages="errors.quantityUnity"
            background-color="white"
            :disabled="disabled || continuous"
          />
        </v-col>

        <v-col lg="3" dense>
          <v-combobox
            v-model="applicationSite"
            outlined
            dense
            label="*Local"
            :items="applicationSites"
            item-text="name"
            :hide-details="errors.applicationSite === undefined"
            :error-messages="errors.applicationSite"
            background-color="white"
            :disabled="disabled"
          />
        </v-col>

        <v-col v-if='isForm' lg="1" dense>
          <v-btn small icon @click="savePrescriptionItem" color="light-blue" :disabled="false" >
            <v-icon>eva-edit-2-outline</v-icon>
          </v-btn> 
        </v-col>
      </v-row>

      <v-row v-if="medicine" dense class="mt-0 mb-0 pt-0 pb-0" align="center" lg="12">
        <v-col>
          <span class="text-subtitle-2">Posologia: </span>
              <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="light-blue" :attrs="attrs" v-on="on" >
              <v-icon @click="savePrescriptionItem">eva-info-outline</v-icon>
            </v-btn>
          </template>
          <span> para confirmar à adição da posologia, clique no ícone ao lado de "preferência de uso" </span>
        </v-tooltip>

          <PrescriptionFormItemAction
            :actionUnities="actionUnities"
            :prescriptionItemId="prescriptionItemId"
            :refreshList="refreshList"
            :prescriptionFrequencies="prescriptionFrequencies"
            :prescriptionPeriods="prescriptionPeriods"
            :prescriptionHowLongs="prescriptionHowLongs"
            :disabled="disabled"
          />
        </v-col>
      </v-row>


      <v-row v-if="medicine.id" dense class="mt-0 mb-0 pt-0 pb-0" align="center" lg="12">
        <v-col cols="11" dense>
          <v-text-field
            v-model="observation"
            outlined
            dense
            hide-details
            label="Observação"
            type="string"
            background-color="white"
            :disabled="disabled"
          />
        </v-col>
        <v-col v-if='isForm' cols="1" dense>
          <v-btn small icon @click="savePrescriptionItem" color="light-blue">
            <v-icon @click="savePrescriptionItem">eva-edit-2-outline</v-icon>
          </v-btn> 
        </v-col>
      </v-row>

      <v-row v-if="prescriptionItemActions.length > 0">
        <v-col>
          <span class="text-subtitle-2">Modos de aplicar</span>



          <PrescriptionFormItemAction
            v-for="prescriptionItemAction in prescriptionItemActions"
            :key="prescriptionItemAction.id"
            :prescriptionItemAction="prescriptionItemAction"
            :actionUnities="actionUnities"
            :prescriptionItemId="prescriptionItemId"
            :refreshList="refreshList"
            :prescriptionFrequencies="prescriptionFrequencies"
            :prescriptionPeriods="prescriptionPeriods"
            :prescriptionHowLongs="prescriptionHowLongs"
            :disabled="disabled"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
import PrescriptionFormItemAction from "@/components/prescription/form/item_action.vue";
import QuerySearchDropdown from "@/components/ui/form/query_search_dropdown.vue";

import GET_MEDICINE_APPLICATION_ROUTES from "@/graphql/medicine/medicine_application_routes.gql";
import GET_MEDICINES_QUERY from "@/graphql/medicines.gql";
import SAVE_PRESCRIPTION_ITEM from "@/graphql/prescription/save_prescription_item.gql";

export default {
  name: "PrescriptionFormItem",
  components: {
    PrescriptionFormItemAction,
    QuerySearchDropdown,
  },
  props: {
    attendance: Object,
    prescriptionItem: {
      type: Object,
      default: () => {
        return {
          id: "",
        };
      },
    },

    others: Boolean,
    prescriptionId: String,
    prescriptionInput: Object,
    clearFlag: String,
    applicationRoute: Object,
    refreshList: Function,
    prescriptionFrequencies: Array,
    prescriptionPeriods: Array,
    prescriptionHowLongs: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errors: {},
      skipSave: false,
      isForm: false,
      prescriptionItemId: "",
      applicationRouteTab: null,
      medicineExtraName: null,
      medicine: "",
      presentation: "",
      quantity: 1,
      quantityUnity: "",
      applicationSite: "",
      observation: "",
      continuous: false,
      getMedicinesQuery: GET_MEDICINES_QUERY,
      applicationRoutesList: [],
      applicationRoutesIdSelected: "",
      typeMedicine: false,
      filteredMedicineManual: {},
    };
  },
  created: function() {
    this.fetchMedicines();
    this.fetchApplicationRoutes();
    if (this.isForm) {

    this.debouncedSavePrescriptionItem = this.lodash.debounce(
      this.savePrescriptionItem,
      40000
    )} else {
    this.debouncedSavePrescriptionItem = this.lodash.debounce(
      this.savePrescriptionItem,
      2500
    )
     }
  },

  watch: {
    typeMedicine(val) {
      console.log(val);
      this.onTypeMedicineChange();
    },

    'prescriptionItem.medicine.name'(newVal) {
      if (newVal && this.prescriptionItem.medicineExtraName) {
        this.typeMedicine = true;
        console.log(newVal);
      }
    },

    prescriptionItem: {
      handler() {
      if (this.prescriptionItem.id !== "") {
        this.skipSave =  true
        this.isForm = true

        this.prescriptionItemId = this.prescriptionItem.id;

        if (this.prescriptionItem.medicineExtraName && this.prescriptionItem.medicine.name == "EXTRA") {
          this.typeMedicine = true;
          this.medicineExtraName = this.prescriptionItem.medicineExtraName;
        } else {
          this.typeMedicine = false;

        }

        this.medicine = this.prescriptionItem.medicine;

        this.presentation = this.lodash.find(this.presentations, { id: this.prescriptionItem.presentation.id });
        this.quantity = this.prescriptionItem.presentationQuantity;
        this.quantityUnity = this.lodash.find(this.quantityUnities, { id: this.prescriptionItem.presentationUnity.id });
        this.applicationSite = this.lodash.find(this.applicationSites, { id: this.prescriptionItem.applicationSite.id }); 
        this.continuous = this.prescriptionItem.continuous; 
        this.observation = this.prescriptionItem.observation;

      } else {
        this.presentation = this.lodash.first(this.presentations);
        this.quantity = 1;
        this.quantityUnity = this.lodash.first(this.quantityUnities);
        this.actionQuantity = 1;
        this.observation = "";
      }

    },
    immediate: true,
    deep: true,
  },

   medicine() {
      this.debouncedSavePrescriptionItem();
   },

    clearFlag() {
      this.skipSave = true;
      this.errors = {};
      this.prescriptionItemId = "";
      this.medicineExtraName = null;
      this.medicine = {};
      this.presentation = "";
      this.quantity = 1;
      this.quantityUnity = "";
      this.applicationSite = "";
      this.actionQuantity = 1;
      this.observation = "";
      this.continuous = false;

      this.skipSave = true;
    }, 
    presentation() {
      this.debouncedSavePrescriptionItem();
    },

    quantity() {
      this.debouncedSavePrescriptionItem();
    },

    quantityUnity() {
      this.debouncedSavePrescriptionItem();
    },

    applicationSite() {
      this.debouncedSavePrescriptionItem();
    },

    prescriptionInput() {
      if (this.prescriptionItemId !== "") {
        this.debouncedSavePrescriptionItem();
      }
    },

    observation() {
      this.debouncedSavePrescriptionItem();
    },

    medicineExtraName() {
      if (this.medicineExtraName !== null && this.typeMedicine === true) {
        this.medicine = this.filteredMedicineManual;
      }

      this.debouncedSavePrescriptionItem();
    },

    continuous(continuous) {
      if (continuous) {
        this.presentation = this.lodash.first(this.presentations);
        this.quantityUnity = this.lodash.first(this.quantityUnities);
        this.quantity = 1;
      }
      this.debouncedSavePrescriptionItem();
    },
  }, 

  computed: {
    presentations() {
      if (this.applicationRoute) {
        return this.applicationRoute.presentations;
      }

      return [];
    },
    quantityUnities() {
      if (this.presentation) {
        return this.presentation.presentationUnities;
      }

      return [];
    },
    applicationSites() {
      return this.applicationRoute?.applicationSites || [];
    },
    actionUnities() {
      if (this.presentation) {
        return this.presentation.presentationActions;
      }

      return [];
    },
    prescriptionItemActions() {
      return this.lodash.orderBy(
        this.prescriptionItem.actions,
        ["createdAt"],
        ["asc"]
      );
    },
  },

methods: { 
         selectFirstElement() {
          this.quantity = 1;
          this.quantityUnity = this.lodash.first(this.quantityUnities);
     },

    onTypeMedicineChange() {
      if (!this.typeMedicine) {
        this.medicine = "";
      }
    },
    

  async fetchApplicationRoutes() { 
    try {
      const response = await this.$apollo.query({
        query: GET_MEDICINE_APPLICATION_ROUTES,
        variables: {
          others: true
        },
        fetchPolicy: "cache-first"
      });

      if (Array.isArray(response.data.medicineApplicationRoutes)) {
        this.applicationRoutesList =  response.data.medicineApplicationRoutes
        this.applicationRoutesList.push({ id: "", name: "" })
      } 
    } catch (error) {
      console.error('Erro ao buscar os medicamentos:', error);
    }
  },
  async fetchMedicines() { 
    try {
      const response = await this.$apollo.query({
        query: GET_MEDICINES_QUERY,
        variables: {
         searchQuery: "EXTRA"
        },

        fetchPolicy: "cache-first",
      });

      if (Array.isArray(response.data.medicines.collection)) {
        this.filteredMedicineManual = response.data.medicines.collection[0]
      } 
    } catch (error) {
      console.error('Erro ao buscar os medicamentos:', error);
    }
  },


  loadMedicine() {
    if (this.prescriptionItem.id !== "") {
      this.medicine = this.prescriptionItem.medicine;
      if (this.prescriptionItem.medicineExtraName) {
        this.typeMedicine = true;
        this.medicineExtraName = this.prescriptionItem.medicineExtraName;
      } else {
        this.typeMedicine = false;
      }
    }
  },

    validatePrescriptionItem() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      if (!this.medicine || !this.medicine.id) {
        this.errors.medicine = errorMsg;
      }
      if (!this.presentation || !this.presentation.id) {
        this.errors.presentation = errorMsg;
      }
      if (!this.quantityUnity || !this.quantityUnity.id) {
        this.errors.quantityUnity = errorMsg;
      }
      if (!this.applicationSite || !this.applicationSite.id) {
        this.errors.applicationSite = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    }, 


    savePrescriptionItem() {
      if (this.disabled) return;

      if (this.skipSave) {
        this.skipSave = false;
        return;
      }

      if (this.isForm) {
        if (this.medicine.name == "EXTRA") {
          this.typeMedicine = true
        } else {
          this.typeMedicine = false
          this.medicineExtraName = null
        }
      }

      if (!this.validatePrescriptionItem()) return;
      let savePrescriptionItemData = {
          attendanceId: this.attendance.id,
          prescriptionId: this.prescriptionId,
          prescriptionItemId: this.prescriptionItemId,
          medicineId: this.medicine.id,
          medicineExtraName: this.medicineExtraName,
          presentationId: this.presentation.id,
          presentationUnityId: this.quantityUnity.id,
          presentationQuantity: `${this.quantity}`,
          applicationRouteId: this.applicationRoute.id,
          applicationSiteId: this.applicationSite.id,
          prescriptionInput: this.prescriptionInput,
          observation: this.observation.substring(0, 90),
          continuous: this.continuous,
        }

      this.apolloMutate({
        mutation: SAVE_PRESCRIPTION_ITEM,
        variables: savePrescriptionItemData,
      }).then(({ data }) => {
        this.$emit(
          "updatePrescriptionId",
          data.savePrescriptionItem.prescription.id
        );
        this.prescriptionItemId = data.savePrescriptionItem.id;

        this.$router.replace(`/prontuario/${this.attendance.id}/receituario/${data.savePrescriptionItem.prescription.id}`);

        this.refreshList();

      })
      ;
    },
  },
};
</script>

<style lang="scss" scoped></style>
